import { useState, useEffect } from 'react'
import { Form, Modal, Button, message, Radio } from 'antd'
import { useAppDispatch } from '../../app/hooks'
import config from '../../config/config'
import iconConfig from './iconfont.json'
import {
  setIconSearchAsync
} from '../../reducers/users/usersSlice'

import { createFromIconfontCN } from '@ant-design/icons';
const IconFont = createFromIconfontCN({
  scriptUrl: `${config.domain}/static/iconfont.js`
});
interface propsObject {
  visible: boolean;
  setVisible: Function;
  record: any;
  setRecord: Function;
  getList: Function
}
const SetIconModal = (props: propsObject) => {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false)
  const [form] = Form.useForm()
  useEffect(() => {
    if (props.visible) {
      form.setFieldsValue({
        name: props.record.name
      })
    }
  }, [props.visible])
  const closeModal = () => {
    props.setVisible(false)
    props.setRecord({})
    props.getList()
  }
  const onFinish = async() => {
    form.validateFields().then(async(values: any) => {
      const params = values
      params.id = props.record.id
      setLoading(true)
      const result = await dispatch(setIconSearchAsync(params))
      setLoading(false)
      const { payload } = result
      if (payload) {
        const { code, msg } = payload
        if (code === 0) {
          message.success('Successful operation');
          closeModal()
        } else if (msg) {
          Modal.error({
            title: 'Error',
            content: msg,
          });
        }
      }
      if (typeof payload === 'string') {
        Modal.error({
          title: 'Error',
          content: payload
        })
      }
    })
  }
  return (
    <>
      <Form form={form} name="control-hooks">
        <Modal
          visible={props.visible}
          width='600px'
          title="Set Icon"
          onCancel={closeModal}
          footer={[
            <Button htmlType="submit" key="submit" loading={loading} type="primary" onClick={onFinish}>
              Ok
            </Button>,
            <Button key="back" onClick={closeModal}>
              Cancel
            </Button>
          ]}
        >
          <Form.Item name="icon" label="Icon" rules={[{ required: true }]}>
            <Radio.Group>
              {
                iconConfig.glyphs.map((obj) => (
                  <Radio key={obj.icon_id} value={`${iconConfig.css_prefix_text}${obj.font_class}`}>
                    <IconFont type={`${iconConfig.css_prefix_text}${obj.font_class}`} />
                  </Radio>
                ))
              }
            </Radio.Group>
          </Form.Item>
        </Modal>
      </Form>
    </>
  );
}

export default SetIconModal
